<div class="flex flex-col bg-white comic-book">

  <div class="container mx-auto px-4 py-8">
    <h1 class="text-4xl font-bangers mb-6">Privacy Policy</h1>
    
    <p class="mb-4">Last updated: 2024/10/07</p>
    
    <h2 class="text-2xl font-semibold mb-3">Introduction</h2>
    <p class="mb-4">At Study Heroes, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and safeguard your data when you use our website, StudyHeroes.app, and our services.</p>
    
    <h2 class="text-2xl font-semibold mb-3">Information We Collect</h2>
    <p class="mb-4">We may collect the following types of information:</p>
    <ul class="list-disc list-inside mb-4">
      <li><strong>Personal Information:</strong> Such as your name, email address, and profile information when you create an account or use our services.</li>
      <li><strong>Usage Data:</strong> Information on how you interact with our website and services, including pages visited, time spent, and features used.</li>
      <li><strong>Device Information:</strong> Data about the device you use to access our services, including device type, operating system, and browser type.</li>
    </ul>
    
    <h2 class="text-2xl font-semibold mb-3">How We Use Your Information</h2>
    <p class="mb-4">We use the collected information for various purposes, including:</p>
    <ul class="list-disc list-inside mb-4">
      <li>Providing and improving our services</li>
      <li>Personalizing your experience</li>
      <li>Communicating with you about our services and updates</li>
      <li>Analyzing usage patterns to enhance our website and services</li>
    </ul>
    
    <h2 class="text-2xl font-semibold mb-3">Data Sharing and Disclosure</h2>
    <p class="mb-4">We do not sell your personal information. We may share your information with:</p>
    <ul class="list-disc list-inside mb-4">
      <li>Service providers who assist us in operating our website and services</li>
      <li>Law enforcement or other authorities if required by law</li>
      <li>Other parties with your consent or at your direction</li>
    </ul>
    
    <h2 class="text-2xl font-semibold mb-3">Data Security</h2>
    <p class="mb-4">We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
    
    <h2 class="text-2xl font-semibold mb-3">Your Rights</h2>
    <p class="mb-4">You have the right to:</p>
    <ul class="list-disc list-inside mb-4">
      <li>Access, correct, or delete your personal information</li>
      <li>Object to or restrict the processing of your data</li>
      <li>Request a copy of your data in a portable format</li>
    </ul>
    
    <h2 class="text-2xl font-semibold mb-3">Changes to This Privacy Policy</h2>
    <p class="mb-4">We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
    
    <h2 class="text-2xl font-semibold mb-3">Contact Us</h2>
    <p class="mb-4">If you have any questions about this Privacy Policy, please contact us at <a href="mailto:wave@studyheroes.app">{{ 'wave@studyheroes.app' }}</a></p>
  </div>

</div>